export const initTransitions = () => {
  const elements = Array.from(
    document.querySelectorAll(
      '.transition-fade, .transition-left, .transition-right',
    ),
  );
  let remainingElements = elements.length;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('transition-show');
          remainingElements--;
          observer.unobserve(entry.target);
        }
      });

      if (remainingElements === 0) {
        observer.disconnect();
      }
    },
    {
      threshold: 0.1,
    },
  );

  elements.forEach((el) => observer.observe(el));
};
